var exports = {
  "Y": "xa15a2ab7--b31ae3--anchor",
};

module.exports = exports;
